//TODO: Move to Chops?

const getSessionStorageValue = (storageKey: string): string | null | undefined => {
  try {
    return sessionStorage.getItem(storageKey);
  } catch {
    //Do Nothing
  }
};

export default getSessionStorageValue;
